import React from "react";
import { Bold, Italic, List, Link } from "lucide-react";

const RichToolbar: React.FC<{ editor: any }> = ({ editor }) => {
  if (!editor) return null;

  const btn = (active: boolean, onClick: () => void, icon: React.ReactNode) => (
    <button
      type="button"
      onClick={onClick}
      className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all ${
        active
          ? "bg-blue-600 text-white shadow-md"
          : "text-slate-500 hover:bg-slate-100"
      }`}
    >
      {icon}
    </button>
  );

  return (
    <div className="flex items-center gap-1 p-2 border-b border-slate-100 bg-slate-50/50">
      {btn(editor.isActive("bold"), () => editor.chain().focus().toggleBold().run(), <Bold size={14} />)}
      {btn(editor.isActive("italic"), () => editor.chain().focus().toggleItalic().run(), <Italic size={14} />)}
      {btn(editor.isActive("bulletList"), () => editor.chain().focus().toggleBulletList().run(), <List size={14} />)}
      {btn(
        editor.isActive("link"),
        () => {
          const url = window.prompt("URL :");
          if (url) editor.chain().focus().setLink({ href: url }).run();
        },
        <Link size={14} />
      )}
    </div>
  );
};

export default RichToolbar;